import { useEffect, useRef } from 'react'
import { useAuthStore } from '../stores/authStore'
import api from '../lib/api'

const PUBLIC_PATHS = ['/login', '/forgot-password', '/reset-password']

let globalAttempted = false

export function useSession() {
  const user = useAuthStore((s) => s.user)
  const isLoading = useAuthStore((s) => s.isLoading)
  const setAuth = useAuthStore((s) => s.setAuth)
  const setReadOnly = useAuthStore((s) => s.setReadOnly)
  const logout = useAuthStore((s) => s.logout)
  const setLoading = useAuthStore((s) => s.setLoading)
  const attemptedRef = useRef(globalAttempted)

  useEffect(() => {
    if (attemptedRef.current) return
    if (globalAttempted) return

    const pathname = window.location.pathname
    if (PUBLIC_PATHS.some((p) => pathname.startsWith(p))) return

    attemptedRef.current = true
    globalAttempted = true

    const restoreSession = async () => {
      setLoading(true)
      try {
        const { data } = await api.post('/auth/refresh')
        if (data.user) {
          setAuth(data.user)
          // Si el backend marca al usuario como demo, activar read-only
          if (data.user.isDemo) {
            setReadOnly(true)
          }
        }
      } catch {
        logout()
      } finally {
        setLoading(false)
      }
    }

    restoreSession()
  }, [setAuth, setReadOnly, logout, setLoading])

  return { isLoading: isLoading && !user }
}
